import { useEffect, useState } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://app.normascan.fr';

/**
 * Indique si l'inscription self-service est ouverte, d'après `GET /api/info`.
 *
 * Le drapeau vit dans le `.env` du serveur (`SIGNUP_ENABLED`) et non dans le
 * bundle React : rouvrir les inscriptions ne demandera donc pas de rebuild du
 * frontend, juste un redémarrage de l'API.
 *
 * ⚠️ Ceci ne sert QU'À l'affichage. La serrure est côté serveur : `/api/register`
 * renvoie 403 quand le drapeau est faux, indépendamment de ce que fait le front.
 * Ne jamais s'en servir comme d'un contrôle d'accès.
 *
 * Retourne `null` tant que la réponse n'est pas arrivée — ce qui permet de ne
 * rien afficher plutôt que de faire clignoter un lien qui va disparaître.
 * En cas d'erreur réseau, on retourne `false` : par défaut on ferme.
 */
export function useSignupEnabled() {
  const [signupEnabled, setSignupEnabled] = useState(null);

  useEffect(() => {
    let annule = false;

    fetch(`${API_BASE_URL}/api/info`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((data) => {
        if (!annule) setSignupEnabled(Boolean(data?.signup_enabled));
      })
      .catch(() => {
        if (!annule) setSignupEnabled(false);
      });

    return () => { annule = true; };
  }, []);

  return signupEnabled;
}

export default useSignupEnabled;
